export interface Subdivision {
    code: string;
    name: string;
}

export const US_STATES: Subdivision[] = [
    {code: 'AL', name: 'Alabama'},
    {code: 'AK', name: 'Alaska'},
    {code: 'AZ', name: 'Arizona'},
    {code: 'AR', name: 'Arkansas'},
    {code: 'CA', name: 'California'},
    {code: 'CO', name: 'Colorado'},
    {code: 'CT', name: 'Connecticut'},
    {code: 'DE', name: 'Delaware'},
    {code: 'FL', name: 'Florida'},
    {code: 'GA', name: 'Georgia'},
    {code: 'HI', name: 'Hawaii'},
    {code: 'ID', name: 'Idaho'},
    {code: 'IL', name: 'Illinois'},
    {code: 'IN', name: 'Indiana'},
    {code: 'IA', name: 'Iowa'},
    {code: 'KS', name: 'Kansas'},
    {code: 'KY', name: 'Kentucky'},
    {code: 'LA', name: 'Louisiana'},
    {code: 'ME', name: 'Maine'},
    {code: 'MD', name: 'Maryland'},
    {code: 'MA', name: 'Massachusetts'},
    {code: 'MI', name: 'Michigan'},
    {code: 'MN', name: 'Minnesota'},
    {code: 'MS', name: 'Mississippi'},
    {code: 'MO', name: 'Missouri'},
    {code: 'MT', name: 'Montana'},
    {code: 'NE', name: 'Nebraska'},
    {code: 'NV', name: 'Nevada'},
    {code: 'NH', name: 'New Hampshire'},
    {code: 'NJ', name: 'New Jersey'},
    {code: 'NM', name: 'New Mexico'},
    {code: 'NY', name: 'New York'},
    {code: 'NC', name: 'North Carolina'},
    {code: 'ND', name: 'North Dakota'},
    {code: 'OH', name: 'Ohio'},
    {code: 'OK', name: 'Oklahoma'},
    {code: 'OR', name: 'Oregon'},
    {code: 'PA', name: 'Pennsylvania'},
    {code: 'RI', name: 'Rhode Island'},
    {code: 'SC', name: 'South Carolina'},
    {code: 'SD', name: 'South Dakota'},
    {code: 'TN', name: 'Tennessee'},
    {code: 'TX', name: 'Texas'},
    {code: 'UT', name: 'Utah'},
    {code: 'VT', name: 'Vermont'},
    {code: 'VA', name: 'Virginia'},
    {code: 'WA', name: 'Washington'},
    {code: 'WV', name: 'West Virginia'},
    {code: 'WI', name: 'Wisconsin'},
    {code: 'WY', name: 'Wyoming'},
    {code: 'DC', name: 'District of Columbia'},
];

export const CA_PROVINCES: Subdivision[] = [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'YT', name: 'Yukon' },
];

export const AU_STATES: Subdivision[] = [
    { code: 'AU-NSW', name: 'New South Wales' },
    { code: 'AU-QLD', name: 'Queensland' },
    { code: 'AU-SA',  name: 'South Australia' },
    { code: 'AU-TAS', name: 'Tasmania' },
    { code: 'AU-VIC', name: 'Victoria' },
    { code: 'AU-WA',  name: 'Western Australia' },
    { code: 'AU-ACT', name: 'Australian Capital Territory' },
    { code: 'AU-NT',  name: 'Northern Territory' },
]

export const IN_SUBDIVISIONS: Subdivision[] = [
    { code: 'IN-AP', name: 'Andhra Pradesh' },
    { code: 'IN-AS', name: 'Assam' },
    { code: 'IN-BR', name: 'Bihar' },
    { code: 'IN-CT', name: 'Chhattisgarh' },
    { code: 'IN-GA', name: 'Goa' },
    { code: 'IN-GJ', name: 'Gujarat' },
    { code: 'IN-HR', name: 'Haryana' },
    { code: 'IN-HP', name: 'Himachal Pradesh' },
    { code: 'IN-JH', name: 'Jharkhand' },
    { code: 'IN-JK', name: 'Jammu & Kashmir' },
    { code: 'IN-KA', name: 'Karnataka' },
    { code: 'IN-KL', name: 'Kerala' },
    { code: 'IN-MP', name: 'Madhya Pradesh' },
    { code: 'IN-MH', name: 'Maharashtra' },
    { code: 'IN-MN', name: 'Manipur' },
    { code: 'IN-ML', name: 'Meghalaya' },
    { code: 'IN-MZ', name: 'Mizoram' },
    { code: 'IN-NL', name: 'Nagaland' },
    { code: 'IN-OR', name: 'Odisha' },
    { code: 'IN-PB', name: 'Punjab' },
    { code: 'IN-RJ', name: 'Rajasthan' },
    { code: 'IN-SK', name: 'Sikkim' },
    { code: 'IN-TN', name: 'Tamil Nadu' },
    { code: 'IN-TG', name: 'Telangana' },
    { code: 'IN-TR', name: 'Tripura' },
    { code: 'IN-UP', name: 'Uttar Pradesh' },
    { code: 'IN-UT', name: 'Uttarakhand' },
    { code: 'IN-WB', name: 'West Bengal' },
    { code: 'IN-AN', name: 'Andaman & Nicobar Islands' },
    { code: 'IN-CH', name: 'Chandigarh' },
    { code: 'IN-DN', name: 'Dadra & Nagar Haveli' },
    { code: 'IN-DD', name: 'Daman & Diu' },
    { code: 'IN-DL', name: 'Delhi (NCT)' },
    { code: 'IN-LD', name: 'Lakshadweep' },
    { code: 'IN-PY', name: 'Puducherry' },
];

export const CN_PROVINCES: Subdivision[] = [
    { code: 'CN-AH', name: 'Anhui(安徽省)' },
    { code: 'CN-BJ', name: 'Beijing(北京市)' },
    { code: 'CN-CQ', name: 'Chongqing(重庆市)' },
    { code: 'CN-FJ', name: 'Fujian(福建省)' },
    { code: 'CN-GS', name: 'Gansu(甘肃省)' },
    { code: 'CN-GD', name: 'Guangdong(广东省)' },
    { code: 'CN-GX', name: 'Guangxi(广西壮族自治区)' },
    { code: 'CN-GZ', name: 'Guizhou(贵州省)' },
    { code: 'CN-HI', name: 'Hainan(海南省)' },
    { code: 'CN-HE', name: 'Hebei(河北省)' },
    { code: 'CN-HA', name: 'Henan(河南省)' },
    { code: 'CN-HK', name: 'Hong Kong(香港特别行政区)' },
    { code: 'CN-HL', name: 'Heilongjiang(黑龙江省)' },
    { code: 'CN-HB', name: 'Hubei(湖北省)' },
    { code: 'CN-HN', name: 'Hunan(湖南省)' },
    { code: 'CN-JS', name: 'Jiangsu(江苏省)' },
    { code: 'CN-JX', name: 'Jiangxi(江西省)' },
    { code: 'CN-JL', name: 'Jilin(吉林省)' },
    { code: 'CN-LN', name: 'Liaoning(辽宁省)' },
    { code: 'CN-MO', name: 'Macao(澳门特别行政区)' },
    { code: 'CN-NM', name: 'Inner Mongolia(内蒙古自治区)' },
    { code: 'CN-NX', name: 'Ningxia(宁夏回族自治区)' },
    { code: 'CN-QH', name: 'Qinghai(青海省)' },
    { code: 'CN-SN', name: 'Shaanxi(陕西省)' },
    { code: 'CN-SX', name: 'Shanxi(山西省)' },
    { code: 'CN-SD', name: 'Shandong(山东省)' },
    { code: 'CN-SH', name: 'Shanghai(上海市)' },
    { code: 'CN-SC', name: 'Sichuan(四川省)' },
    { code: 'CN-TJ', name: 'Tianjin(天津市)' },
    { code: 'CN-XJ', name: 'Xinjiang(新疆维吾尔自治区)' },
    { code: 'CN-XZ', name: 'Tibet(西藏自治区)' },
    { code: 'CN-YN', name: 'Yunnan(云南省)' },
    { code: 'CN-ZJ', name: 'Zhejiang(浙江省)' },
    { code: 'CN-TW', name: 'Taiwan(台湾省)' },
]

export const IT_PROVINCES: Subdivision[] = [
    { code: 'AG', name: 'Agrigento' },
    { code: 'AL', name: 'Alessandria' },
    { code: 'AN', name: 'Ancona' },
    { code: 'AO', name: 'Aosta' },
    { code: 'AR', name: 'Arezzo' },
    { code: 'AP', name: 'Ascoli Piceno' },
    { code: 'AT', name: 'Asti' },
    { code: 'AV', name: 'Avellino' },
    { code: 'BA', name: 'Bari' },
    { code: 'BT', name: 'Barletta-Andria-Trani' },
    { code: 'BL', name: 'Belluno' },
    { code: 'BN', name: 'Benevento' },
    { code: 'BG', name: 'Bergamo' },
    { code: 'BI', name: 'Biella' },
    { code: 'BO', name: 'Bologna' },
    { code: 'BZ', name: 'Bolzano (South Tyrol)' },
    { code: 'BS', name: 'Brescia' },
    { code: 'BR', name: 'Brindisi' },
    { code: 'CA', name: 'Cagliari' },
    { code: 'CL', name: 'Caltanissetta' },
    { code: 'CB', name: 'Campobasso' },
    { code: 'CE', name: 'Caserta' },
    { code: 'CT', name: 'Catania' },
    { code: 'CZ', name: 'Catanzaro' },
    { code: 'CH', name: 'Chieti' },
    { code: 'CO', name: 'Como' },
    { code: 'CS', name: 'Cosenza' },
    { code: 'CR', name: 'Cremona' },
    { code: 'KR', name: 'Crotone' },
    { code: 'CN', name: 'Cuneo' },
    { code: 'EN', name: 'Enna' },
    { code: 'FM', name: 'Fermo' },
    { code: 'FE', name: 'Ferrara' },
    { code: 'FI', name: 'Firenze (Florence)' },
    { code: 'FG', name: 'Foggia' },
    { code: 'FC', name: 'Forlì-Cesena' },
    { code: 'FR', name: 'Frosinone' },
    { code: 'GE', name: 'Genova (Genoa)' },
    { code: 'GO', name: 'Gorizia' },
    { code: 'GR', name: 'Grosseto' },
    { code: 'IM', name: 'Imperia' },
    { code: 'IS', name: 'Isernia' },
    { code: 'SP', name: 'La Spezia' },
    { code: 'AQ', name: "L'Aquila" },
    { code: 'LT', name: 'Latina' },
    { code: 'LE', name: 'Lecce' },
    { code: 'LC', name: 'Lecco' },
    { code: 'LI', name: 'Livorno' },
    { code: 'LO', name: 'Lodi' },
    { code: 'LU', name: 'Lucca' },
    { code: 'MC', name: 'Macerata' },
    { code: 'MN', name: 'Mantova (Mantua)' },
    { code: 'MS', name: 'Massa-Carrara' },
    { code: 'MT', name: 'Matera' },
    { code: 'ME', name: 'Messina' },
    { code: 'MI', name: 'Milano (Milan)' },
    { code: 'MO', name: 'Modena' },
    { code: 'MB', name: 'Monza e Brianza' },
    { code: 'NA', name: 'Napoli (Naples)' },
    { code: 'NO', name: 'Novara' },
    { code: 'NU', name: 'Nuoro' },
    { code: 'OR', name: 'Oristano' },
    { code: 'PD', name: 'Padova (Padua)' },
    { code: 'PA', name: 'Palermo' },
    { code: 'PR', name: 'Parma' },
    { code: 'PV', name: 'Pavia' },
    { code: 'PG', name: 'Perugia' },
    { code: 'PU', name: 'Pesaro e Urbino' },
    { code: 'PE', name: 'Pescara' },
    { code: 'PC', name: 'Piacenza' },
    { code: 'PI', name: 'Pisa' },
    { code: 'PT', name: 'Pistoia' },
    { code: 'PN', name: 'Pordenone' },
    { code: 'PZ', name: 'Potenza' },
    { code: 'PO', name: 'Prato' },
    { code: 'RG', name: 'Ragusa' },
    { code: 'RA', name: 'Ravenna' },
    { code: 'RC', name: 'Reggio Calabria' },
    { code: 'RE', name: 'Reggio Emilia' },
    { code: 'RI', name: 'Rieti' },
    { code: 'RN', name: 'Rimini' },
    { code: 'RM', name: 'Roma (Rome)' },
    { code: 'RO', name: 'Rovigo' },
    { code: 'SA', name: 'Salerno' },
    { code: 'SS', name: 'Sassari' },
    { code: 'SV', name: 'Savona' },
    { code: 'SI', name: 'Siena' },
    { code: 'SO', name: 'Sondrio' },
    { code: 'SU', name: 'South Sardinia' },
    { code: 'SR', name: 'Siracusa (Syracuse)' },
    { code: 'TA', name: 'Taranto' },
    { code: 'TE', name: 'Teramo' },
    { code: 'TR', name: 'Terni' },
    { code: 'TP', name: 'Trapani' },
    { code: 'TN', name: 'Trento' },
    { code: 'TV', name: 'Treviso' },
    { code: 'TS', name: 'Trieste' },
    { code: 'TO', name: 'Torino (Turin)' },
    { code: 'UD', name: 'Udine' },
    { code: 'VA', name: 'Varese' },
    { code: 'VE', name: 'Venezia (Venice)' },
    { code: 'VB', name: 'Verbano-Cusio-Ossola' },
    { code: 'VC', name: 'Vercelli' },
    { code: 'VR', name: 'Verona' },
    { code: 'VV', name: 'Vibo Valentia' },
    { code: 'VI', name: 'Vicenza' },
    { code: 'VT', name: 'Viterbo' },
];

export const JP_PREFECTURES: Subdivision[] = [
    { code: 'JP-01', name: 'Hokkaido(北海道)' },
    { code: 'JP-02', name: 'Aomori(青森県)' },
    { code: 'JP-03', name: 'Iwate(岩手県)' },
    { code: 'JP-04', name: 'Miyagi(宮城県)' },
    { code: 'JP-05', name: 'Akita(秋田県)' },
    { code: 'JP-06', name: 'Yamagata(山形県)' },
    { code: 'JP-07', name: 'Fukushima(福島県)' },
    { code: 'JP-08', name: 'Ibaraki(茨城県)' },
    { code: 'JP-09', name: 'Tochigi(栃木県)' },
    { code: 'JP-10', name: 'Gunma(群馬県)' },
    { code: 'JP-11', name: 'Saitama(埼玉県)' },
    { code: 'JP-12', name: 'Chiba(千葉県)' },
    { code: 'JP-13', name: 'Tokyo(東京都)' },
    { code: 'JP-14', name: 'Kanagawa(神奈川県)' },
    { code: 'JP-15', name: 'Niigata(新潟県)' },
    { code: 'JP-16', name: 'Toyama(富山県)' },
    { code: 'JP-17', name: 'Ishikawa(石川県)' },
    { code: 'JP-18', name: 'Fukui(福井県)' },
    { code: 'JP-19', name: 'Yamanashi(山梨県)' },
    { code: 'JP-20', name: 'Nagano(長野県)' },
    { code: 'JP-21', name: 'Gifu(岐阜県)' },
    { code: 'JP-22', name: 'Shizuoka(静岡県)' },
    { code: 'JP-23', name: 'Aichi(愛知県)' },
    { code: 'JP-24', name: 'Mie(三重県)' },
    { code: 'JP-25', name: 'Shiga (滋賀県)' },
    { code: 'JP-26', name: 'Kyoto(京都府)' },
    { code: 'JP-27', name: 'Osaka(大阪府)' },
    { code: 'JP-28', name: 'Hyogo(兵庫県)' },
    { code: 'JP-29', name: 'Nara(奈良県)' },
    { code: 'JP-30', name: 'Wakayama(和歌山県)' },
    { code: 'JP-31', name: 'Tottori(鳥取県)' },
    { code: 'JP-32', name: 'Shimane(島根県)' },
    { code: 'JP-33', name: 'Okayama(岡山県)' },
    { code: 'JP-34', name: 'Hiroshima(広島県)' },
    { code: 'JP-35', name: 'Yamaguchi(山口県)' },
    { code: 'JP-36', name: 'Tokushima(徳島県)' },
    { code: 'JP-37', name: 'Kagawa(香川県)' },
    { code: 'JP-38', name: 'Ehime(愛媛県)' },
    { code: 'JP-39', name: 'Kochi(高知県)' },
    { code: 'JP-40', name: 'Fukuoka(福岡県)' },
    { code: 'JP-41', name: 'Saga(佐賀県)' },
    { code: 'JP-42', name: 'Nagasaki(長崎県)' },
    { code: 'JP-43', name: 'Kumamoto(熊本県)' },
    { code: 'JP-44', name: 'Oita(大分県)' },
    { code: 'JP-45', name: 'Miyazaki(宮崎県)' },
    { code: 'JP-46', name: 'Kagoshima(鹿児島県)' },
    { code: 'JP-47', name: 'Okinawa(沖縄県)' },
];

export const MX_STATES: Subdivision[] = [
    // States
    { code: 'AGS', name: 'Aguascalientes' },
    { code: 'CHIH', name: 'Chihuahua' },
    { code: 'COAH', name: 'Coahuila' },
    { code: 'COL', name: 'Colima' },
    { code: 'DGO', name: 'Durango' },
    { code: 'BC', name: 'Baja California' },
    { code: 'BCS', name: 'Baja California Sur' },
    { code: 'CAMP', name: 'Campeche' },
    { code: 'CHIS', name: 'Chiapas' },
    { code: 'MEX', name: 'México' },
    { code: 'MICH', name: 'Michoacán' },
    { code: 'GTO', name: 'Guanajuato' },
    { code: 'GRO', name: 'Guerrero' },
    { code: 'HGO', name: 'Hidalgo' },
    { code: 'MOR', name: 'Morelos' },
    { code: 'NAY', name: 'Nayarit' },
    { code: 'NL', name: 'Nuevo León' },
    { code: 'OAX', name: 'Oaxaca' },
    { code: 'PUE', name: 'Puebla' },
    { code: 'JAL', name: 'Jalisco' },
    { code: 'QRO', name: 'Querétaro' },
    { code: 'QR', name: 'Quintana Roo' },
    { code: 'SIN', name: 'Sinaloa' },
    { code: 'SON', name: 'Sonora' },
    { code: 'TAB', name: 'Tabasco' },
    { code: 'TAMPS', name: "Tamaulipas" },
    { code: "TLAX", name:"Tlaxcala"},
    { code: 'VER', name: 'Veracruz' },
    { code: 'YUC', name: 'Yucatán' },
    { code: 'ZAC', name: 'Zacatecas' },
    { code: 'SLP', name: 'San Luis Potosí' },
    // Federal District
    { code: 'CDMX', name: 'Ciudad de México' },
];

export const BR_STATES: Subdivision[] = [
    { code: 'AC', name: 'Acre' },
    { code: 'AL', name: 'Alagoas' },
    { code: 'AP', name: 'Amapá' },
    { code: 'AM', name: 'Amazonas' },
    { code: 'BA', name: 'Bahia' },
    { code: 'CE', name: 'Ceará' },
    { code: 'DF', name: 'Distrito Federal' },
    { code: 'ES', name: 'Espírito Santo' },
    { code: 'GO', name: 'Gojás' },
    { code: 'MA', name: 'Maranhão' },
    { code: 'MT', name: 'Mato Grosso' },
    { code: 'MS', name: 'Mato Grosso do Sul' },
    { code: 'MG', name: 'Minas Gerais' },
    { code: 'PA', name: 'Pará' },
    { code: 'PB', name: 'Paraíba' },
    { code: 'PR', name: 'Paraná' },
    { code: 'PE', name: 'Pernambuco' },
    { code: 'PI', name: 'Piauí' },
    { code: 'RJ', name: 'Rio de Janeiro' },
    { code: 'RN', name: 'Rio Grande do Norte' },
    { code: 'RS', name: 'Rio Grande do Sul' },
    { code: 'RO', name: 'Rondônia' },
    { code: 'RR', name: 'Roraima' },
    { code: 'SC', name: 'Santa Catarina' },
    { code: 'SP', name: "São Paulo" },
    { code: "SE", name:"Sergipe"},
    { code: 'TO', name: 'Tocantins' },
];

export const MY_STATES: Subdivision[] = [
    // States
    { code: 'PLS', name: 'Perlis' },
    { code: 'KDH', name: 'Kedah' },
    { code: 'PNG', name: 'Penang' },
    { code: 'PRK', name: 'Perak' },
    { code: 'SGR', name: 'Selangor' },
    { code: 'NSN', name: 'Negeri Sembilan' },
    { code: 'MLK', name: 'Malacca' },
    { code: 'JHR', name: 'Johor' },
    { code: 'KTN', name: 'Kelantan' },
    { code: 'TRG', name: 'Terengganu' },
    { code: 'PHG', name: 'Pahang' },
    { code: 'SBH', name: 'Sabah' },
    { code: 'SRW', name: 'Sarawak' },
    // Federal Territory
    { code: 'LBN', name: 'Labuan' },
    { code: 'KLS', name: 'Kuala Lumpur' },
    { code: 'PJY', name: 'Putrajaya' },
];

export const KR_PROVINCES: Subdivision[] = [
    { code: 'KR-26', name: 'Busan(부산광역시)' },
    { code: 'KR-43', name: 'Chungbuk(충청북도)' },
    { code: 'KR-44', name: 'Chungnam(충청남도)' },
    { code: 'KR-27', name: 'Daegu(대구광역시)' },
    { code: 'KR-30', name: 'Daejeon(대전광역시)' },
    { code: 'KR-42', name: 'Gangwon(강원특별자치도)' },
    { code: 'KR-29', name: 'Gwangju(광주광역시)' },
    { code: 'KR-41', name: 'Gyeonggi(경기도)' },
    { code: 'KR-47', name: 'Gyeongbuk(경상북도)' },
    { code: 'KR-48', name: 'Gyeongnam(경상남도)' },
    { code: 'KR-28', name: 'Incheon(인천광역시)' },
    { code: 'KR-49', name: 'Jeju(제주특별자치도)' },
    { code: 'KR-45', name: 'Jeonbuk(전라북도)' },
    { code: 'KR-46', name: 'Jeonnam(전라남도)' },
    { code: 'KR-50', name: 'Sejong(세종)' },
    { code: 'KR-11', name: 'Seoul(서울특별시)' },
    { code: 'KR-31', name: 'Ulsan(울산광역시)' }
];
